// ENG-676: default the FBX convert wizard's body/face toggle from the filename.
// Face animation FBX are conventionally named "*_face.fbx" (e.g.
// isaac_take15_face.fbx); everything else defaults to body.
export function defaultFbxAnimKind(filename) {
  return /face/i.test(filename ?? '') ? 'face' : 'body'
}
